import { Component } from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, Label, PrimaryButton, TextField, Toggle } from 'office-ui-fabric-react';
import FileManager from '../FileManager/FileManager';
import { IMetaGallery, IMetaGalleryVideo } from 'app/services/content-type';
import { FileTypes, IFile } from 'app/services/file-manager';
import { getFilePath } from 'app/utils/service';
import { validateUrl } from 'app/shared/functions';
import ImageVideo from "assets/images/type-video.jpg"

type MetaPhotoType = "thumbnail" | "src" | "";

type MetaVideoType = "thumbnail" | "src" | "";

interface MetaGalleryModalProps {
    show: boolean;
    data: IMetaGallery | null;
    videoData: IMetaGalleryVideo | null;
    onSave: (data?: IMetaGallery | null ,  videoData?: IMetaGalleryVideo | null) => void;
    onDismiss: () => void;
}

interface MetaGalleryModalState {
    data: IMetaGallery | null;
    modalKey: MetaPhotoType;
    videoData?: IMetaGalleryVideo | null;
    modalKeyVideo: MetaVideoType;
    selectedFile: IFile | null;
    selectedVideoFile: IFile | null;
}
export class MetaGalleryModal extends Component<MetaGalleryModalProps, MetaGalleryModalState> {

    state = {
        data: this.props.data || null,
        modalKey: "" as MetaPhotoType,
        videoData: this.props.videoData || null,
        modalKeyVideo: "" as MetaVideoType,
        selectedFile: {} as IFile, 
        selectedVideoFile: {} as IFile
    }
    renderFileManager() {
        return (
            <FileManager
                show={this.state.modalKey ? true : false}
                onDismiss={() => this.setState({ modalKey: "" })}
                activeFile={this.state.selectedFile}
                onSelectedFile={(file) => {
                    const key = this.state.modalKey as MetaPhotoType;
                    this.setState({
                        data: {
                            ...this.state.data,
                            [key]: file.fileName
                        } as IMetaGallery,
                        selectedFile: file
                    })
                }}
                fileType={FileTypes.Image}
            />
        )
    }
    renderFileManagerVideo() {
        return (
            <FileManager
                show={this.state.modalKeyVideo ? true : false}
                onDismiss={() => this.setState({ modalKeyVideo: "" })}
                activeFile={this.state.selectedVideoFile}
                onSelectedFile={(file) => {
                    const key = this.state.modalKeyVideo as MetaVideoType;
                    this.setState({
                        videoData: {
                            ...this.state.videoData,
                            [key]: file.fileName
                        } as IMetaGalleryVideo,
                        selectedVideoFile: file
                    })
                }}
                fileType={FileTypes.Video}
            />
        )
    }
    renderImage(imageKey: MetaPhotoType) {
        const image = this.state.data ? this.state.data[imageKey] : "";
        const splitted = image?.split(".");
        const imageSource = this.state.data && this.state.data[imageKey]
        ? validateUrl(this.state.data[imageKey]) ? this.state.data[imageKey] : (getFilePath() + this.state.data[imageKey] + (!splitted || splitted[splitted?.length - 1] !== "svg" ? "?width=200&height=200" : ""))
        : "";
        const setModalKey = (key: MetaPhotoType) => new Promise<void>((resolve) => this.setState({ modalKey: key }, resolve));
        const disableimage =  this.state.videoData?.src 

        return (
            <div className="image-field row">
                {image && (
                    <img className="image-string-field" src={imageSource} alt="" />
                )}
                <TextField
                    className="custom-textfield col no-padding"
                    value={image}
                    disabled={this.state.videoData?.src? true : false}
                    onChange={(event: any) => {
                        this.setState({ data: { ...this.state.data, [imageKey]: event.target.value as string } as IMetaGallery })
                    }}
                />
                <DefaultButton
                    className="custom-button"
                    text="Görüntüle"
                    style={{ marginTop: 2.5 }}
                    disabled={!imageSource}
                    onClick={() => {
                        window.open(imageSource, "_blank")
                    }}
                />
                <PrimaryButton
                    className="custom-button"
                    text="Görsel Seç"
                    style={{ marginTop: 2.5 }}
                    disabled={disableimage ? true: false}
                    onClick={async () => {
                        await setModalKey(imageKey);
                        this.setState((prevState) => ({
                            data: {
                                ...prevState.data,
                                [imageKey]: this.state.selectedFile?.fileName || "",
                            } as IMetaGallery,
                        }));
                    }}
                    styles={{
                        root: {
                            background: "#33926e !important",
                            borderColor: "#33926e !important"
                        },
                        rootDisabled: {
                            opacity: 0.3,
                            background: "#ececec",
                            color: "#000"
                        }
                    }}
                />
            </div>
        );
    }

    renderVideo(videoKey: MetaVideoType) {
        const video = this.state.videoData ? this.state.videoData[videoKey] : "";
        const splitted = video?.split(".");
        const videoSource = this.state.videoData && this.state.videoData[videoKey]
        ? validateUrl(this.state.videoData[videoKey]) ? this.state.videoData[videoKey] : (getFilePath() + this.state.videoData[videoKey] + (!splitted || splitted[splitted?.length - 1] !== "mp4" ? "?width=200&height=200" : ""))
        : "";
        const setModalKeyVideo = (key: MetaVideoType) => new Promise<void>((resolve) => this.setState({ modalKeyVideo: key }, resolve));
        const disablevideo =  this.state.data?.src || this.state.data?.thumbnail 

        return (
            <div className="image-field row">
                {video && (
                    <img className="image-string-field" src={ImageVideo} alt="" />
                    
                )}
                <TextField
                    className="custom-textfield col no-padding"
                    value={video}
                    disabled={this.state.data?.src? true : false}
                    onChange={(event: any) => {
                        this.setState({ videoData: { ...this.state.videoData, [videoKey]: event.target.value as string } as IMetaGalleryVideo })
                    }}
                />
                <DefaultButton
                    className="custom-button"
                    text="Görüntüle"
                    style={{ marginTop: 2.5 }}
                    disabled={!videoSource}
                    onClick={() => {
                        window.open(videoSource, "_blank")
                    }}
                />
                <PrimaryButton
                    className="custom-button"
                    text="Video Seç"
                    style={{ marginTop: 2.5 }}
                    disabled={disablevideo ? true: false}
                    onClick={async () => {
                            await setModalKeyVideo(videoKey);
                            this.setState((prevState) => ({
                                videoData: {
                                    ...prevState.videoData,
                                    [videoKey]: this.state.selectedVideoFile?.fileName || "",
                                } as IMetaGalleryVideo,
                            }));
                        }}
                    styles={{
                        root: {
                            background: "#33926e !important",
                            borderColor: "#33926e !important"
                        },
                        rootDisabled: {
                            opacity: 0.3,
                            background: "#ececec",
                            color: "#000"
                        }
                    }}
                />
            </div>
        );
    }

    renderForm() {
        return (
            <div className="meta-form">
                <Label>Fotoğraf</Label>
                {this.renderImage("src")}
                <Label>Öne Çıkarılmış Görsel (Liste Görseli)</Label>
                {this.renderImage("thumbnail")}
                <TextField
                    label="Fotoğraf Başlığı"
                    className="custom-textfield"
                    value={this.state.data?.caption}
                    disabled={this.state.videoData?.src? true : false}
                    onChange={(event: any) => {
                        this.setState({ data: { ...this.state.data, alt: event.target?.value as string, caption: event.target?.value as string } as IMetaGallery })
                    }}
                />
                <TextField
                    label="Fotoğraf Alt Başlığı"
                    className="custom-textfield"
                    disabled={this.state.videoData?.src? true : false}
                    multiline
                    value={this.state.data?.subcaption}
                    onChange={(event: any) => {
                        this.setState({ data: { ...this.state.data, subcaption: event.target?.value as string } as IMetaGallery })
                    }}
                />
                <Label>Video</Label>
                {this.renderVideo("src")}
                <TextField
                    label="Video Başlığı"
                    className="custom-textfield"
                    disabled={this.state.data?.src? true : false}
                    value={this.state.videoData?.caption}
                    onChange={(event: any) => {
                        this.setState({ videoData: { ...this.state.videoData, alt: event.target?.value as string, caption: event.target?.value as string } as IMetaGalleryVideo })
                    }}
                />
                <TextField
                    label="Video Alt Başlığı"
                    className="custom-textfield"
                    disabled={this.state.data?.src? true : false}
                    multiline
                    value={this.state.videoData?.subcaption}
                    onChange={(event: any) => {
                        this.setState({ videoData: { ...this.state.videoData, subcaption: event.target?.value as string } as IMetaGalleryVideo })
                    }}
                />
                <Toggle
                    label="Fotoğraf Yolu Harici Bir URL mi?"
                    className="custom-toggle"
                    checked={this.state.data?.external as boolean}
                    onChange={(_, checked) => {
                        this.setState({ data: { ...this.state.data, external: checked, src: "", thumbnail: "" } as IMetaGallery })
                    }}
                />
            </div>
        )
    }

    render() {
        if (!this.props.show) return null;
        const image = !this.state.data?.src || !this.state.data?.thumbnail;
        const video = !this.state.videoData?.src;

        return (
            <Dialog
                hidden={!this.props.show}
                onDismiss={() => this.props.onDismiss()}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Galeri Öğesini Düzenle",
                    closeButtonAriaLabel: 'Kapat',
                    subText: "Aşağıdan galeri öğesi özelliklerini güncelleyebilirsiniz. Galeri görselini ve öne çıkarılmış görseli girmek zorunludur.",
                }}
                modalProps={{
                    className: "confirm",
                    isBlocking: false,
                    styles: { main: { maxWidth: "1000px !important" } }
                }}
            >
                {this.renderForm()}
                {this.renderFileManager()}
                {this.renderFileManagerVideo()}
                <DialogFooter>
                    <DefaultButton onClick={() => this.props.onDismiss()} text="İptal" />
                    <PrimaryButton
                        disabled={ image && video}
                        onClick={() => {
                            this.props.onSave(this.state.videoData?.src ? this.state.videoData : this.state.data);
                            this.props.onDismiss();
                        }}
                        text="Kaydet"
                    />
                </DialogFooter>
            </Dialog>
        )
    }
}
